import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CartIcon from '../../icons/cart';
import AddToCart from '../AddToCart';
import ReadMore from '../ReadMore';

export default function SeriesThree() {

  document.title = `Series Three | Hanuman Editions`;
  document.querySelector('meta[name="description"]').setAttribute('content', `Series III is attuned to contemporary avant-garde literature, presenting short stories, literary criticism, and even an opera from Jesse Ball, Mario Bellatin, Georgi Gospodinov, Eka Kurniawan and Can Xue.`);


  return (
    <div className='newPageContainer'>

      <div className='booksPage'>
        <h5>Series III</h5>
        <p className='seriesGraf'>Series III is attuned to contemporary avant-garde literature, presenting short stories, literary criticism, and even an opera, from Jesse Ball, Mario Bellatin, Georgi Gospodinov, Eka Kurniawan and Can Xue, four of which are works in translation. The series features a newly expanded reissue of Bob Flanagan’s legendary <em>Fuck Journal</em>, from the Hanuman Books catalogue, with a foreword by Sheree Rose and an introduction by Johanna Hedva.  </p>
        <ReadMore>
          <p><strong>Design Note</strong></p>
          <br />
          <p>
            The design for Hanuman Editions Series III evokes <em>Thought-Forms: A Clairvoyant Investigation</em>, a foundational Theosophical text published by revolutionary figure Annie Besant in 1905. Each book cover corresponds to a related drawing from <em>Thought-Forms</em> and its rich imaginary of psychic abstraction that, like Hanuman Editions, has its roots in India, and travels recursively between disciplinary currents.
          </p>
        </ReadMore>

        <div className='gridThree'>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/kafka-and-i-can-xue' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/CanXue_06_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Kafka & I</div>
                <div className='nb-author'>Can Xue</div>
              </div>
              <div className='gridThree_addToCart'>
                <AddToCart context={'landing'} id={'9798989378067'} />
              </div>
            </div>
          </div>

          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/history-of-the-dolls-jesse-ball' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/JesseBall_07_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>
              </Link>


            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>

                <div className='nb-title'>The History of the Dolls and What They Did</div>
                <div className='nb-author'>Jesse Ball</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416529'} />
              </div>
            </div>

          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/mishimas-head-mario-bellatin' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/MarioBellatin_08_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Mishima's Head</div>
                <div className='nb-author'>Mario Bellatin</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416512'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/space-opera-georgi-gospodinov' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/GeorgiGospodinov_09_Mockup2.webp) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Space Opera</div>
                <div className='nb-author'>Georgi Gospodinov</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416505'} />
              </div>
            </div>
          </div>


          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/love-never-dies-eka-kurniawan' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/EkaKurniawan_10_Mockup2.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>


            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Love Never Dies</div>
                <div className='nb-author'>Eka Kurniawan</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798989378098'} />
              </div>
            </div>
          </div>
          <div className='gridThree_item'>
            <div className='gridThree_cover'>
              <Link to='/books/fuck-journal-bob-flanagan' className='gridThree_bookCover' style={{
                background: `url(../../Series-Three/Flanagan_Side.png) lightgray -262.792px -410.946px / 276.409% 293.368% no-repeat`
              }}>

              </Link>
            </div>
            <div className='gridThree_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Fuck Journal</div>
                <div className='nb-author'>Bob Flanagan</div>
              </div>
              <div>
                <AddToCart context={'landing'} id={'9798990416536'} />
              </div>
            </div>
          </div>

        </div>


        <div className='boxGrid'>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <Link to='/limited/series-three-box-set-purple' className='boxGrid_graphic boxGrid_graphicThree' style={{ backgroundImage: `url(../../Boxsets/Boxset_Series_III_Multiview_Purple.png)` }}></Link>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series III Box Set</div>
                <div className='nb-author'>Purple</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_03_pp'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <Link to='/limited/series-three-box-set-mid-green' className='boxGrid_graphic boxGrid_graphicThree' style={{ backgroundImage: `url(../../Boxsets/Boxset_Series_III_Multiview_MidGreen.png)` }}></Link>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series III Box Set</div>
                <div className='nb-author'>Mid-Green</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_03_mg'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <Link to='/limited/series-three-box-set-neon-yellow' className='boxGrid_graphic boxGrid_graphicThree' style={{ backgroundImage: `url(../../Boxsets/Boxset_Series_III_Multiview_Neon.png)` }}></Link>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series III Box Set</div>
                <div className='nb-author'>Neon Yellow</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_03_ny'} />
              </div>
            </div>
          </div>
          <div className='boxGrid_item'>
            <div className='boxGrid_image'>
              <Link to='/limited/series-three-box-set-rose' className='boxGrid_graphic boxGrid_graphicThree' style={{ backgroundImage: `url(../../Boxsets/Boxset_Series_III_Multiview_Gmund36.png)` }}></Link>
            </div>
            <div className='boxGrid_controls'>
              <div className='gridThree_description'>
                <div className='nb-title'>Series III Box Set</div>
                <div className='nb-author'>Rose</div>
              </div>
              <div>
                <AddToCart context='landing' id={'hanuman_box_03_rs'} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}